import "../styles/Visionaries.css";
import pic from "../assets/a.png";
import pic1 from "../assets/b.png";
import pic2 from "../assets/c.png";

const people = [
  {
    name: "SETH GIRDHARI LAL JI BIHANI",
    role: "Founder",
    img: pic,
  },
  {
    name: "MRS. TEEJADEVI BIHANI",
    role: "Maatrshakti",
    img: pic1,
  },
  {
    name: "SETH SHUSHIL KUMAR JI BIHANI",
    role: "Bhamashah",
    img: pic2,
  },
];

export default function Visionaries() {
  return (
    <section className="visionaries-section">
      <div className="visionaries-header">
        <h1>OUR </h1>
        <span>VISIONARIES</span>
      </div>
      <div className="visionaries-container">
        {people.map((person, index) => (
          <div className="visionary-card" key={index}>
            <div className="image-wrapper">
              <img src={person.img} alt={person.name} />
            </div>

            <h3>{person.name}</h3>
            <p>({person.role})</p>
          </div>
        ))}
      </div>
    </section>
  );
}